export default __webpack_public_path__ + "static/media/B6.6d9959f2.mp3";